import API from "@/api";
import { getField, updateField } from "vuex-map-fields";
import moment from "moment";

const initialState = () => ({
  versaoAtualRegulamento: [],
  dsTermosUso: [],
  dtCriacao: [],
  dominio: process.env.VUE_APP_DEFAULT_REALM_KEY
    ? process.env.VUE_APP_DEFAULT_REALM_KEY
    : "profissional",
});

export const state = initialState();

export const getters = {
  getField,
  getDtAtualizacao: (state) => {
    return formatDate(state.dtCriacao, true);
  },
};

function formatDate(date, includeTimestamp = true) {
  if (!date) return "";
  return moment(date).format(`DD/MM/YYYY ${includeTimestamp ? "HH:mm" : ""}`);
}

export const actions = {
  async getRegulamentoAtual({ commit, state }) {
    const dominio = state.dominio;
    const res = await API.axios.get(
      `/bff/api/v1/regulamentos/${dominio}/atual`
    );

    if (res.status !== 200) {
      commit("updateField", { path: "dsTermosUso", value: "" });
      commit("updateField", { path: "dtCriacao", value: "" });
      return { status: res.status };
    }

    commit("updateField", {
      path: "dsTermosUso",
      value: res.data.dsTermoUso,
    });
    commit("updateField", { path: "dtCriacao", value: res.data.dtCriacao });
    return { status: res.status };
  },
  async getVersaoAndDtCriacao({ commit, state }) {
    const dominio = state.dominio;
    const res = await API.axios.get(
      `/bff/api/v1/regulamentos/${dominio}/atual/versao`
    );

    if (res.status !== 200) {
      commit("updateField", {
        path: "versaoAtualRegulamento",
        value: "",
      });
      commit("updateField", { path: "dtCriacao", value: "" });

      return { status: res.status };
    }

    commit("updateField", {
      path: "versaoAtualRegulamento",
      value: res.data.versao,
    });
    commit("updateField", {
      path: "dtCriacao",
      value: res.data.dtCriacao,
    });
    return { status: res.status };
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
